import { formatNumber, getCurrencySymbol } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { CurrencySetting } from '@us/web/shared/data-access';
import { selectCurrencySetting } from '../+state/shop.reducer';
import { isNumber } from 'lodash';
import { filter, tap } from 'rxjs';

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    currencySetting: CurrencySetting = {
        display_decimal: false,
        display_currency_unit: false,
        display_reduce_price: false,
        currency_unit: 'đ'
    };

    constructor(private store: Store, @Inject(LOCALE_ID) private locale: string) {
        this.store
            .select(selectCurrencySetting)
            .pipe(
                untilDestroyed(this),
                filter(e => !!e),
                tap(setting => {
                    this.currencySetting = {
                        display_decimal: !!+setting.display_decimal,
                        display_currency_unit: !!+setting.display_currency_unit,
                        display_reduce_price: !!+setting.display_reduce_price,
                        currency_unit: setting.currency_unit
                    };
                })
            )
            .subscribe();
    }

    format(
        value: number | string | null | undefined,
        currencyCode?: string,
        display: 'code' | 'symbol' | 'symbol-narrow' | string = 'symbol',
        digitsInfo?: string,
        locale?: string
    ): string {
        if (!isNumber(value)) {
            return value || '';
        }

        if (digitsInfo === undefined) {
            digitsInfo = this.currencySetting.display_decimal ? '1.2-2' : '1.0-0';
        }

        if (locale === undefined) {
            locale = 'en-US'; // this.locale;
        }

        let currency: string =
            currencyCode || (this.currencySetting.display_currency_unit ? this.currencySetting.currency_unit : '');
        if (display !== 'code') {
            if (display === 'symbol' || display === 'symbol-narrow') {
                currency = getCurrencySymbol(currency, display === 'symbol' ? 'wide' : 'narrow', locale);
            } else {
                currency = display;
            }
        }

        return `${formatNumber(value, locale, digitsInfo)} ${currency}`; // ? force currency to be after number
        // return formatCurrency(value, locale, currency, undefined, digitsInfo);
    }
}
